"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getComponent = exports.XIndicator = exports.StyledReactSelectAsync = exports.StyledReactSelect = exports.StyledCreatableSelectAsync = exports.StyledCreatableSelect = exports.MultiValue = exports.LoadingIndicator = exports.DropdownIndicator = exports.DropdownArrow = exports.ClearIndicator = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _reactSelect = _interopRequireWildcard(require("react-select3"));
var _loading_spinner = _interopRequireDefault(require("../loading_spinner"));
var _icons = require("../../icons");
var _constants = require("../../constants");
var _legacy_select = require("../dropdown_resources/legacy_select");
var _creatable = _interopRequireDefault(require("react-select3/creatable"));
var _asyncCreatable = _interopRequireDefault(require("react-select3/async-creatable"));
var _async = _interopRequireDefault(require("react-select3/async"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _underscore = _interopRequireDefault(require("underscore"));
var _chip = require("../chip");
var _excluded = ["children"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var MultiValue = exports.MultiValue = function MultiValue(_ref) {
  var children = _ref.children,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_chip.Chip, {
    key: props.key,
    status: "default",
    text: children,
    onRemove: props.removeProps.onClick
  });
};
var DropdownIndicator = exports.DropdownIndicator = function DropdownIndicator(props) {
  return /*#__PURE__*/_react["default"].createElement(_reactSelect.components.DropdownIndicator, props, /*#__PURE__*/_react["default"].createElement(DropdownArrow, {
    menuIsOpen: props.selectProps.menuIsOpen
  }));
};
var LoadingIndicator = exports.LoadingIndicator = function LoadingIndicator(props) {
  return /*#__PURE__*/_react["default"].createElement(_loading_spinner["default"], {
    flavor: props.flavor,
    size: 'small'
  });
};
var StyledXIcon = (0, _styledComponents["default"])(_icons.XIcon).withConfig({
  displayName: "components__StyledXIcon"
})(["margin-top:2px;"]);
var XIndicator = exports.XIndicator = function XIndicator() {
  return /*#__PURE__*/_react["default"].createElement(StyledXIcon, {
    size: 14
  });
};
var ClearIndicator = exports.ClearIndicator = function ClearIndicator(props) {
  return /*#__PURE__*/_react["default"].createElement(_reactSelect.components.ClearIndicator, props, XIndicator());
};
var DropdownArrow = exports.DropdownArrow = _styledComponents["default"].div.withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !['menuIsOpen'].includes(prop);
  }
}).withConfig({
  displayName: "components__DropdownArrow"
})(["border-color:#666666 transparent transparent;border-style:solid;border-width:5px 5px 2.5px;display:inline-block;height:0;width:0;position:relative;top:2px;", ""], function (props) {
  return props.menuIsOpen && "\n    top: 0px;\n    border-color: transparent transparent ".concat(_constants.colors.darkGrey, ";\n    border-width: 0 5px 5px;\n  ");
});

// **************
// Wrap with Styled component for some custom things
// **************
var DropdownWrapper = _styledComponents["default"].span.withConfig({
  displayName: "components__DropdownWrapper"
})([".sl-dropdown__group .sl-dropdown__option{padding-left:40px;}.sl-dropdown__option{height:auto;}"]);
var WithStyledDropdownWrapper = function WithStyledDropdownWrapper(Component) {
  var WrappedComponent = function WrappedComponent(props) {
    return /*#__PURE__*/_react["default"].createElement(DropdownWrapper, null, /*#__PURE__*/_react["default"].createElement(Component, props));
  };
  WrappedComponent.displayName = "WithStyledDropdownWrapper(".concat(Component.displayName);
  return WrappedComponent;
};
var StyledReactSelect = exports.StyledReactSelect = WithStyledDropdownWrapper(_reactSelect["default"]);
var StyledReactSelectAsync = exports.StyledReactSelectAsync = WithStyledDropdownWrapper(_async["default"]);
var StyledCreatableSelect = exports.StyledCreatableSelect = WithStyledDropdownWrapper(_creatable["default"]);
var StyledCreatableSelectAsync = exports.StyledCreatableSelectAsync = WithStyledDropdownWrapper(_asyncCreatable["default"]);
var getComponent = exports.getComponent = function getComponent(props) {
  if (props.isTiered) {
    return _legacy_select.TieredDropdown;
  }
  if (props.isVirtualized) {
    return _legacy_select.VirtualizedDropdown;
  }
  if (props.isLazyLoad) {
    return props.isCreatable ? StyledCreatableSelect : StyledReactSelect;
  }
  if (_underscore["default"].isFunction(props.options)) {
    return props.isCreatable ? StyledCreatableSelectAsync : StyledReactSelectAsync;
  }
  return props.isCreatable ? StyledCreatableSelect : StyledReactSelect;
};